/**
 * A point written as an SVG path's coordinate pair, rounded to hundredths
 * of the 24 grid: finer than any screen draws it, and short enough that a
 * path computed every frame stays a short string.
 */export default function svgPoint(point){return"".concat(point.x.toFixed(2)," ").concat(point.y.toFixed(2));}